import Version from './Version';
import './Version.css';
import { connect } from 'react-redux';

// Redux
const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
    cardNumber: state.loyalty.cardNumber,
  };
}

const ConnectedVersion = connect(
  mapStateToProps
)(Version);

export default ConnectedVersion;



// WEBPACK FOOTER //
// ./src/pages/Version/index.js